import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/counter_monitor.template.htm';
import 'dhtmlxMessage';
import QueueStatisticsCollection from '../models/queues_statistics.paginated.collection.ts';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import i18n  from "l10n";
import "../../libs/jquery-countdown/js/jquery.countdown.min.js";

import TicketsTemplate from 'text-loader!../templates/tickets_counter.template.htm'; //toDo: REMOVE IT
import AppointmentsTemplate from 'text-loader!../templates/appointments_counter.template.htm'; //toDo: REMOVE IT

export default GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	ticketsTemplate: Handlebars.compile(TicketsTemplate),
	appointmentsTemplate: Handlebars.compile(AppointmentsTemplate),
	userData: null,
	queueData: null,
	counterData: null,
	currentTicket: null,
	queueStatistic: null,
	isFirstDisplay: true,
	interval: null,
	queueFifo: [],
	initialize: function (options) {
		self = this;
		this.userData = options.data;

        this.amIAssigned();
        this.nextButtonClicked = false;

        //Bind `toggleLogs` buttons
		this.keys = {};
        $(document).off("keydown").on("keydown",function (e) {
            if(e.which == 16 || e.which == 17 || e.which == 76)
                self.keys[e.which] = true;
            if(self.keys[16] && self.keys[17] && self.keys[76]) {
                self.toggleLogs();
                delete self.keys[self.keys[76]];
            }
        });
        $(document).off("keyup").on("keyup",function (e) {
            delete self.keys[e.which];
        });

        /**
         * popstate is fired on:
         *  - url change
         *  - BACK button pressed
         *  - FORWARD button pressed
        */
        $(window).off("popstate").on("popstate", function() {
            if(self.interval)
                clearInterval(self.interval);
        });

        $(window).off("unload").on("unload", function(e) {
            e.preventDefault(); //do not show Confirm popup

            self.clearListener("beforeunload");

            if(self.interval)
                clearInterval(self.interval);

            return false;
        });

        setTimeout(function() { self.clearListener("timeout"); }, 8 * 1000);

        this.queueStatisticsCollection = new QueueStatisticsCollection();
        this.queueStatisticsCollection.off('sync').on('sync', this.successQueueStatistics, this);
        //this.queueStatisticsCollection.off('error').on('error', this.errorQueueStatistics, this);
	},
	superRender: GenericView.prototype.render,
	render: function () {
	    this.superRender();
	    this.isFirstDisplay = false;

        this.$el.html(this.template(
        {
			userData: this.userData,
			queueData: this.queueData,
			counterData: this.counterData
        }));

        $("#counter-name").html(this.counterData.name);

        this.showServingTicket();
        this.getServicingTicketBeginTime();
        this.updateNextPatient();
	},
	events:{
		"click #closeBtn": "closeCounter",
		"click #nextBtn": "actionNextTicket",
		//"click #didNotComeBtn": "actionDidNotComeNextTicket",
		"click .log-icon": "changeLogsPanel",
		"click .refresh-icon": function() { this.getAllTickets(); this.getAllAppointments(); }
	},
	changeLogsPanel: function(event) {
	    var self = this;
	    $("#log-panels").find(".active").removeClass("active");

	    $("#logs-buttons").find(".active").removeClass("active");

	    var $cTarget = $(event.currentTarget);
	    $cTarget.addClass("active");

	    $("#" + $cTarget.data("id")).addClass("active");
	},
	getServicingTicketBeginTime: function() {
	    //it will be checked on page load
        var isCurrentlyATicketBeingServed = (this.currentTicket && this.currentTicket.status == "Servicing"
                            && this.currentTicket.serviceBeginTime && !this.currentTicket.serviceEndTime);
	    var self = this;
	    if(isCurrentlyATicketBeingServed) {
	        //if a ticket is currently being served and the TIMER hasn't ended,
	        //but the timer has stopped (page reloaded), restart it with the remaining time
	        this.setCountdownForNextButton(this.currentTicket.serviceBeginTime);
            $('#minimumServiceTime').countdown("start");
	        this.toggleNextButtons();
	    }
	},
	toggleLogs: function() {
	    $("#tickets_logs_container").slideToggle();
	},
	closeCounter: function()
	{
	    var self = this;
		this.showActionProgressBar();

		$.when(window.ping()).then(function(re) {
            $.when(self.servicedTicket("makeCloseRequest")).then(function(resp) {

                if(resp == true || (resp.status && resp.data.status == "Pre_Serviced" || resp.data.status == "Serviced")) {
                    self.makeCloseRequest();
                }
            });

		});
	},
	makeCloseRequest: function()
	{
		var self = this;
		var data = { counterId: this.counterData.id};
		this.showActionProgressBar();

		$.when(window.ping()).then(function(re) {
		    self.doCall("rest/api/agent/counters/close", "POST", self.successCloseCounter, self.errorCloseCounter, data);

		});
	},
	successCloseCounter: function(response, status, xhr, self)
	{
		self.hideActionProgressBar();
		window.open('./#AgentQueues','_self');
	},
	errorCloseCounter: function(response, self)
	{
		self.hideActionProgressBar();
	},
	amIAssigned: function()
	{
		this.doCall("rest/api/agent/counters/assigned?extra=queue", "GET", this.successAmIAssigned, this.errorAmIAssigned);
	},
	successAmIAssigned: function(response, status, xhr, self)
	{
  		if(status == "success")
		{
			if(response.data != null)
			{
			    if(response.data.counter.status == "Open") {
                    self.queueData = response.data.queue;
                    self.counterData = response.data.counter;
                    self.amIServingTicket();
                    return;
                }
			}
		}
		window.open('./','_self');
	},
	errorAmIAssigned: function(response, self)
	{
		window.open('./','_self');
	},
	amIServingTicket: function()
	{
		this.doCall("rest/api/agent/tickets/current?queueId="+ encodeURIComponent(this.queueData.id) +"&extra=customer", "GET", this.successAmIServingTicket, this.errorAmIServingTicket );
	},
	successAmIServingTicket: function(response, status, xhr, self)
	{
		if(status == "success")
		{
			if(response.data != null && response.data.ticket != null)
			{
				self.currentTicket = response.data.ticket.id != null ? response.data.ticket : null
				self.customerCode = response.data.customer != null ? response.data.customer.customerCode : null;

				self.nextCustomerCode = response.data.ticket.nextCustomerCode;
                self.nextTicketNumber = response.data.ticket.nextTicketNumber;
			}else {
                self.nextCustomerCode = response.data != null ? response.data.nextCustomerCode : null;
                self.nextTicketNumber = response.data != null ? response.data.nextTicketNumber : null;
			}
			self.updateNextPatient();
		}
		self.loadQueueStatistics();
	},
	errorAmIServingTicket: function(response, self)
	{
	    $.notify(i18n.t('counter.noPendingTickets'), { position:"top center", className: "info" });
		self.loadQueueStatistics();
	},
	showServingTicket: function()
	{
		$("#servingTickets").html(i18n.t("agent.serving")+"<br/>" +this.getServingTicketPrompt());
		this.updateCustomerCode();
        this.getAllTickets();
        this.getAllAppointments();
	},
	updateCustomerCode: function()
	{
	    var self = this;
	    var txt = i18n.t("counter.cuscode") + "<br/>";
	    var cusCode = txt + (self.currentTicket && self.customerCode != null ? self.customerCode : "-");

		$("div#customerCode").html(cusCode);
	},
	getServingTicketPrompt: function()
	{
		if(this.currentTicket == null)
			return "-";

        // we create the "A" or "B" named, ticket number, in the backend
        //return "#" + this.currentTicket.displayNumber; //toDO: use it in a future version

        var ticketPrefix = "#";
        if(this.currentTicket.isPriorityTicket)
            ticketPrefix += "A";
        else
            ticketPrefix += "B";
        //return ticketPrefix + this.currentTicket.number; //todo: removed
        return "#" + this.currentTicket.number;
	},
	loadQueueStatistics: function()
	{
        this.queueStatisticsCollection.url =  "rest/api/statistics/queues?filter=" + encodeURIComponent("queue="+this.queueData.id+",date>=" + this.getTodayWithOffset(0) + ", date<=" + this.getTodayWithOffset(0));
        this.queueStatisticsCollection.getFirstPage();
	},
	successQueueStatistics: function(response, status, xhr)
	{
	    var self = this;
		if(this.isFirstDisplay)
		{
			this.setListener();
            this.interval = setInterval(function() { self.checkAndRenewSocketJSConnections(self); }, 10 * 1000);
			this.render();
		}

		if(this.queueStatisticsCollection.models.length > 0)
			this.queueStatistic = this.queueStatisticsCollection.models[0];

		this.updatePendingTickets();
	},
	updatePendingTickets: function()
	{
		if(this.queueStatistic){

			var pendingCount = "0"
			if(this.queueStatistic.attributes)
				pendingCount = this.queueStatistic.attributes.pendingCount;
			else
				pendingCount = this.queueStatistic.pendingCount;

			if(pendingCount < 0)
				pendingCount = 0;

			$('#pendingTickets').html(i18n.t("analytics.pending")+"<br/>" +pendingCount);
		}

	},
	updateNextPatient: function()
	{
	    var self = this;
        var ticket_number = self.nextTicketNumber  ? self.nextTicketNumber : "-";
        var customer_code = self.nextCustomerCode  ? "( " +self.nextCustomerCode  +" )" : "";

        //$("#ticket-number").text(ticket_number); //toDo: removed
        $("#ticket-number").text( ticket_number.substr(1) );
        $("#next-patient-code").text(customer_code);

	},
	removeOnePendingTickets: function()
	{
		this.queueStatisticsCollection.models[0].attributes.pendingCount = this.queueStatisticsCollection.models[0].attributes.pendingCount -1;
	},
	errorQueueStatistics: function(collection, self)
	{
		this.onErrorHandler(response, xhr, options);
		this.render();
	},
	toggleNextButtons: function() {
	    var self = this;

        this.nextButtonClicked = false;

        if(!this.currentTicket) { //no more tickets to serve
            //return NEXT buttons, to their initial state
            //$("#nextBtn").prop('disabled', false);
            //$("#didNotComeBtn").prop('disabled', true);

            $("#nextBtn").show();
            $("#didNotComeBtn").hide();

            return;
        }

        //toggle enabled/disabled on `NEXT` & `DID NOT COME` buttons
    	//$("#nextBtn").prop('disabled', !($("#nextBtn").prop('disabled')));
        //$("#didNotComeBtn").prop('disabled', !($("#didNotComeBtn").prop('disabled')));

        $("#nextBtn").toggle();
        $("#didNotComeBtn").toggle();

        this.getAllTickets();
        this.getAllAppointments();
        this.loadQueueStatistics();
	},
	getAllTickets: function() {
	    //used for Logs
	    var self = this;

	    var url = "rest/api/agent/counters/getAllTickets/"+ this.queueData.id;
        $.ajaxDefaultQ({
            url: url,
            type: "GET",
            data: {}
        }).done(function(response, status, xhr){
            $("#tickets_logs").html(self.ticketsTemplate({"data": response.data}));
            if($("#tickets_logs_container").css("display") == "block")
                $.notify("Ticket logs updated", { position:"top center", className: "success" });
        })
        .fail(function(response) {
            self.errorCallback(response, self);
        });
	},
	errorCallback: function(response, self) {
	    console.error("Error: ", response);
	},
	getAllAppointments: function() {
        //used for Logs
        var self = this;

        var url = "rest/api/agent/counters/getAllAppointments/"+ this.queueData.id;
        $.ajaxDefaultQ({
            url: url,
            type: "GET",
            data: {}
        }).done(function(response, status, xhr){
            $("#appointments_logs").html(self.appointmentsTemplate({"data": response.data}));
            if($("#tickets_logs_container").css("display") == "block")
                $.notify("Appointment logs updated", { position:"top center", className: "success" });
        })
        .fail(function(response) {
            self.errorCallback(response, self);
        });
    },
	getFormattedRemainingMinutes: function(minutes) {
	    return Handlebars.helpers.getFormattedRemainingMinutes(minutes);
	},
	setCountdownForNextButton: function(dateFrom) {
	    var self = this;

        //pass a `dateFrom`, in case the timer has already begun and for some reason the page was reloaded,
        //so the timer can know from which time to start the countdown (continue with the current remaining time and not the initial one)
	    var finalDate = new Date((dateFrom != null ? dateFrom : Date.now()) + (this.queueData.minServiceTime * 1000));

        $("#minimumServiceTime").countdown(finalDate)
        .off('update.countdown').on('update.countdown', function(event) {
            $(this).text(event.strftime('%M:%S'));
        }).off('finish.countdown').on('finish.countdown', function(event) {
            self.toggleNextButtons();
            $(this).text(self.getFormattedRemainingMinutes(self.queueData.minServiceTime));
        }).off('stop.countdown').on('stop.countdown', function(event) {
            self.toggleNextButtons();
            $(this).text(self.getFormattedRemainingMinutes(self.queueData.minServiceTime));
        });
	},
	setCountDownDefaultValue: function() {
	    $('#minimumServiceTime').countdown("stop");
        $("#minimumServiceTime").text(this.getFormattedRemainingMinutes(this.queueData.minServiceTime));
	},
	actionNextTicket: function()
	{
	    var self = this;
	    if(this.nextButtonClicked == true)
	        return;

	    this.nextButtonClicked = true;

	    var self = this;
		this.showActionProgressBar();

        $.when(window.ping()).then(function(re) {
            $.when(self.servicedTicket("nextTicket")).then(function(resp) {

                if(resp == true || (resp.data && (resp.data.status == "Pre_Serviced" || resp.data.status == "Serviced"))) {
                    self.setCountdownForNextButton();
                    $('#minimumServiceTime').countdown('start');

                    $.when(window.ping()).then(function(resp) {
                        self.nextTicket(true);
                    });
                }
            });
        });

	},
	actionDidNotComeNextTicket: function()
	{
	    var self = this;
		this.showActionProgressBar();

		this.setCountDownDefaultValue();
		this.nextTicket(false);

		this.setCountdownForNextButton();
		//toggle NEXT/DID_NOT_COME buttons (disabled/enabled)

		this.toggleNextButtons();
	},
	nextTicket: function(hasCustomerCome)
	{
		var self = this;
		var data = "queueId="+this.queueData.id;
		var url = "rest/api/agent/tickets";

		if(!hasCustomerCome) {
		    url += "/didNotCome/next";
		    data += this.currentTicket ? "&ticketId=" + this.currentTicket.id : "";
		}
		else {
		    url += "/next";
		}
		this.doCall(url, "POST",
			function(response, status, xhr){
				self.hideActionProgressBar();
				self.currentTicket = response.data != null && response.data.ticket != null && response.data.ticket.id != null ? response.data.ticket : null;

				self.nextCustomerCode = response.data != null && response.data.ticket != null ? response.data.ticket.nextCustomerCode : null;
				self.nextTicketNumber = response.data != null && response.data.ticket != null ? response.data.ticket.nextTicketNumber : null;
				if(response && response.data.customer && response.data.customer.deviceOs == "NoDevice")
					self.currentPhone = response.data.customer.deviceId;
				else
					self.currentPhone = null;
				self.updatePendingTickets();
				self.showServingTicket();
                self.updateNextPatient();
				self.toggleNextButtons();
			},
			function(status){
				self.hideActionProgressBar();
				self.currentTicket = null;
				self.currentPhone = null;
				self.updatePendingTickets();
				self.showServingTicket();
                self.updateNextPatient();
				self.toggleNextButtons();
				self.setCountDownDefaultValue();

				$("#nextBtn").notify(i18n.t('counter.noPendingTickets'), { position:"top center", className: "info" });
			},
			data
		);
	},
	servicedTicket: function(nextMethod)
	{
		if(this.currentTicket == null) {
		    this.hideActionProgressBar();
		    return true;
		}

		var self = this;
		return $.ajaxDefaultQ({
            url: "rest/api/agent/tickets/serviced?id="+self.currentTicket.id+"&callback="+nextMethod,
            type: "POST",
            async: false,
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
            }
        }).done(function(response) {
              self.hideActionProgressBar();
              return response.data.status;

        }).fail(function(response, status, xhr) {
              self.hideActionProgressBar();
              self.currentTicket = null;

              $.notify(i18n.t('counter.noPendingTickets'), { position:"top center", className: "info" });

              return true;
        });


	},
	doCall: function(url, type, successCallback, errorCallback, data)
	{
		if(!data)
			data = "";

		var self = this;

        return $.ajaxDefaultQ({
            url: url,
            type: type,
            data: data,
            beforeSend: function (xhr) {
                if("post|put|patch|delete".indexOf(type.toLowerCase()) > -1)
                    xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
            },
        }).done(function(response, status, xhr){
            successCallback(response, status, xhr, self);
        })
        .fail(function(response) {
            errorCallback(response, self);
        });
	},
	setListener: function()
	{
		var self = this;

		this.wsocket = new SockJS('rest/live');
		this.client = Stomp.over(this.wsocket);

		var headers = {
			//origin: 'https://www.qedis-metro.com', toDo: enable it
		};

		this.client.connect(headers,
		    function(frame) {
                self.subscribeToStomp(self);
		    },
            function(onCloseMessage) {
                if(onCloseMessage.indexOf('Whoops! Lost connection to') > -1) {
                    self.clearListener("onConnectionClosed");
                }
            }
        );
	},
	subscribeToStomp: function(self) {
	    self.counterStompSubscription = self.client.subscribe('/live/monitors/counters/' + self.counterData.id, function (message){
            var responseObject = JSON.parse( message.body );
            if(responseObject.serverMessage) {
                $.notify(responseObject.serverMessage, { position:"top center", className: "info" });
                return;
            }

            self.loadQueueStatistics();
            self.customerCode = responseObject.customerCode;
            self.updateCustomerCode();

            self.nextCustomerCode = responseObject.nextCustomerCode;
            self.nextTicketNumber = responseObject.nextTicketNumber;
            self.updateNextPatient();
        });
	},
	checkAndRenewSocketJSConnections: function(self) {
        //console.log(">>> Checking for non-connected client.");
	    if(self.client && (!self.client.connected || !self.counterStompSubscription)) {
	        //console.log("Found non-connected client. Trying to reconnect...");
	        //self.setListener();
	        self.subscribeToStomp(self);
	    }else {
	        //console.log("No disconnected client found.");
	    }
	},
	clearListener: function(reason)
	{
        if(!this.client || !this.counterStompSubscription || this.alreadyRequestedClear)
            return;

        this.alreadyRequestedClear = true;

        this.counterStompSubscription.unsubscribe();
        this.counterStompSubscription = null;
        /*this.client.disconnect(function() {

        });*/

        this.alreadyRequestedClear = false;
	},
	clearView: function()
	{
		this.clearListener("clearview");
	}

});

